import $ from 'jquery';
import 'slick-carousel';

ready(qs('.CP-house-wrapper'), () => {
    // ==== VARS =====
    const wrapper = $('.CP-house-wrapper-slick');
    const $wrapper = qs('.CP-house-wrapper-slick');
    const settings = {
        arrows: false,
        dots: true,
    }

    // ===== FUNCTIONS
    const resizeBoxes = () => {
        const $textes = qsa('.CP-house-wrapper .title p');
        const $box = qs('.CP-house-wrapper-slick');
        if ($textes.length > 0) {
            let offsetTop = $textes[0].offsetTop;
            $box.style.marginTop = offsetTop + "px";
        }
    }
    const mobileBehavior = () => {
        wrapper.slick(settings);
        wrapper.slicked = true;
        wrapper.on('init', () => wrapper.slick('slickRemove', $('.title-slide').index(this) - 1))
    }
    const desktopBehavior = () => {
        const $box = qsa('.CP-house-wrapper-box');
        if ($box.length > 0) {
            for (let i = 1; i < $box.length; i++) {
                var items = $box[i].querySelectorAll(".CP-house-push");
                for (let j = 0; j < items.length; j++) {
                    $box[0].appendChild(items[j]);
                }
            }
        }
        resizeBoxes();
        if (wrapper && wrapper.slicked) {
            $(wrapper).slick('unslick');
            wrapper.slicked = false;
        }
    }
    const behavior = () => {
        if (window.innerWidth < 1024) {
            mobileBehavior()
        } else {
            desktopBehavior()
        }
    }
    behavior()
    window.addEventListener('resize', () => {
        behavior()
    })
})


// WEBPACK FOOTER //
// ./src/scripts/components/HouseWrapper.js